import {UIStateVendor} from "../data/UIStateVendor";
import * as React from "react";
import {VendorWrapper} from "./shared/VendorWrapper";

export const VendorWaitingForSetup = () =>
  <VendorWrapper>
    <div>
      <h3 className={'level3'}>Waiting For Setup</h3>
      <p>
        Thank you for creating an account! Now Wellness Concepts has some setup
        to complete before you will be able to sign in and contribute to the system.
      </p>
      <p>
        If you have any questions, or need additional assistance, please contact&nbsp;
        <a href={"mailto:strive@well-concepts.com?subject=Vendor%20System%20Help"}>strive@well-concepts.com</a>
      </p>
      <button className="logout" onClick={UIStateVendor.clearState}>Sign Out</button>
    </div>
  </VendorWrapper>
;